define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const BaseView = require('common/base.view');
    const url = require('util/url.util');
    const config = require('config');
    const core = require('core');
    const i18n = require('i18n');
    const cashierUtil = require('modules/cashier/cashier.util');
    const storage = require('util/storage.util');
    const paymentButtonConfig = require('portlets/cashier/deposit/special/paymentbutton-deposit.method.config');
    const PopupView = require('modules/popup/popup.view');

    const callback = {};
    let instance = null;

    module.exports = BaseView.extend({
        isInitRequest: true,
        supported: false,
        loading: false,
        scriptSrc: null,
        urlParams: null,
        template: 'paymentbutton-deposit.method',
        events: {
            'tap .fn-googlePay' : 'clickGooglePay'
        },

        initialize: function(options) {
            this.options = options;
            this.model = options.model;
            this.form = options.form;
            BaseView.prototype.initialize.apply(this, arguments);
        },
        manageHoverClass: function(action, e) {
            const button = e.currentTarget.querySelector('button');

            button && button.classList[action]('hover');
        },

        clickGooglePay: function() {
            BaseView.prototype.renderOverlay.apply(this, arguments);
        },

        handleButton: function(response) {
            const cachedDefine = window.define;

            window.define = null;
            return new Promise(function(resolve) {
                this.parseUrlParams(response);
                this.injectScript()
                    .then(function() {
                        window.define = cachedDefine;
                        this.destroyPrevious();
                    }.bind(this))
                    .then(this.render.bind(this))
                    .then(this.initializeButton.bind(this))
                    .then(this.createButton.bind(this))
                    .then(() => resolve());
            }.bind(this));
        },

        depositAndRender: function() {
            this.isInitRequest = true;
            const amount = 10.01;
            const cachedDefine = window.define;

            window.define = null;

            return new Promise(function(resolve, reject) {
                this.depositRequest(amount)
                    .fail(function(error) {
                        this.depositErrorHandle(error);
                    }.bind(this))
                    .then(function(response) {
                        this.parseUrlParams(response);
                    }.bind(this))
                    .then(this.injectScript.bind(this))
                    .then(function() {
                        window.define = cachedDefine;
                        this.destroyPrevious();
                    }.bind(this))
                    .then(this.render.bind(this))
                    .then(() => this.initializeButton())
                    .then(() => this.createButton().then(
                        () => { setTimeout(() => resolve(), 1000); },
                        () => { reject(); }
                    ));
            }.bind(this));
        },

        render: function() {
            this.loading = false;
            BaseView.prototype.render.apply(this, arguments);

            this.$el.html(this.tmpl(this.template, {
                amount: this.urlParams.amount,
                currencyCode: this.urlParams.currencyCode,
                code: this.model.get('code'),
                paymentType: this.model.get('_paymentType')
            }));

            return this;
        },

        renderLoader: function() {
            if (this.loading) {
                return;
            }

            this.$el.html(this.tmpl('common.loader'));
            this.loading = true;
        },

        injectScript: function() {
            const isExist = _.some(document.scripts, (script) => script.src === this.scriptSrc);

            return isExist ? Promise.resolve() : $.getScript(this.scriptSrc);
        },

        parseUrlParams: function(response) {
            const headerParameters = response.data.headerParameters;

            this.scriptSrc = this.replaceVersion(headerParameters.Location[0]);
            this.urlParams = url.getURLParams(headerParameters['X-Redirect-Content'][0]);
        },

        initializeButton: function() {
            this.addButtonListeners();

            const initConfig = {
                ...paymentButtonConfig.defaultConfig,
                merchantId: this.urlParams.merchantID,
                merchantName: this.urlParams.merchantName,
                allowedCardNetworks: this.urlParams.allowedCardNetworks.split(','),
                useGooglePay: this.isGoogle(),
                useApplePay: this.isApple()
            };

            if (this.isGoogle()) {
                initConfig.googlePayConfiguration.merchantId = this.urlParams.googlePayMerchantID;
            }

            return window.PaymentButton.init(initConfig);
        },

        createButton: function() {
            return new Promise(function(resolve, reject) {
                const el = this.$el.find('.paybutton')[0];
                const payment = paymentButtonConfig.getPayment(this.urlParams);

                setTimeout(function() {
                    instance = el && window.PaymentButton.create(el, payment);
                    instance.then(() => resolve(), () => reject());
                }, 1000);
            }.bind(this));
        },

        depositRequest: function(amount) {
            let data = {};
            this.hideKeyboard();

            data = this.model.resolveStoredAccount(data);
            data.amount = amount;

            if (this.isInitRequest) {
                data.subMethodsCodes = ['Init'];
                this.isInitRequest = false;
            }

            return this.model.deposit(data);
        },

        onCreate: function() {
            this.supported = true;
            this.$el.parents('.payment-method').show();
            console.log('Payment button created.');
        },

        onError: function(error) {
            console.groupCollapsed('Payment button error.');
            console.warn(error);
            console.groupEnd();
            PopupView.closeAll();
        },

        onAbort: function(abort) {
            console.groupCollapsed('Payment button abort.');
            console.warn(abort);
            console.groupEnd();
            PopupView.closeAll();
        },

        onUnsupported: function(message) {
            const $el = $(`.deposit__${this.model.get('code')}`);

            console.group('Payment button unsupported message.');
            console.warn(message);
            console.groupEnd();

            $el.length && $el.parents('.payment-method').remove();
            this.supported = false;
            PopupView.closeAll();
        },

        onAuthorization: function() {
            storage.session.setItem('GooglePaySuccess', true);
            cashierUtil.notifyTransactionStatus();
            this.close();
            const rootPath = config.get('rootPage') || '/';
            core.navigate(rootPath);
            window.Playtech.API.popup.closePopups('applePayPopup');
            PopupView.closeAll();
        },

        isGoogle: function() {
            return this.model.get('code') === 'GooglePayDT';
        },

        isApple: function() {
            return this.model.get('code') === 'ApplePayDT';
        },

        addButtonListeners() {
            if(window.PaymentButton) {
                this.callback = {
                    authorization: this.onAuthorization.bind(this),
                    error: this.onError.bind(this),
                    abort: this.onAbort.bind(this),
                    unsupported: this.onUnsupported.bind(this),
                    create: this.onCreate.bind(this)
                };
                callback[this.model.get('code')] = this.callback;
                window.PaymentButton.on("authorization", this.callback.authorization);
                window.PaymentButton.on('error', this.callback.error);
                window.PaymentButton.on('abort', this.callback.abort);
                window.PaymentButton.on('unsupported', this.callback.unsupported);
                window.PaymentButton.on('create', this.callback.create);
            }
        },

        removeButtonListeners: function() {
            Object.keys(callback).forEach(function(id) {
                const fn = callback[id] || {};

                for (let prop in fn) {
                    window.PaymentButton && window.PaymentButton.off(prop, fn[prop]);
                }
                callback[id] = null;
            });
        },

        close: function() {
            this.urlParams = null;
            this.destroyPrevious();
            BaseView.prototype.close.apply(this, arguments);
        },

        destroyPrevious: function() {
            if (!window.PaymentButton || !instance) {
                return;
            }

            instance = null;
            this.removeButtonListeners();
            try {
                window.PaymentButton.destroy();
            } catch(error) {
                console.groupCollapsed('Payment button destroy.');
                console.warn(error);
                console.groupEnd();
            }
        },

        replaceVersion: function(urlArg) {
            const arr = _.last(urlArg.split('-')).split('.');
            const version = {
                new: '2.0.0',
                current: _.filter(arr, (item) => Number.isInteger(parseInt(item))).join('.')
            };
            const parsed = {
                new: parseInt(version.new.replace(/\./g, '')),
                current: parseInt(version.current.replace(/\./g, ''))
            };

            if(parsed.current < parsed.new) {
                return urlArg.replace(version.current, version.new);
            }

            return urlArg;
        },

        depositErrorHandle: function(error) {
            let loaderContent = $('.content__loader.fn-loader');
            let errorEl = $('.google-apple-pm-deposit-limit-error');
            let p = errorEl[0] || document.createElement('p');
            !errorEl[0] && p.classList.add('google-apple-pm-deposit-limit-error');
            p.innerHTML = i18n.t('playtech.mobile.system.cashier.depositPaymentsError.' + error.data.errorCode);

            loaderContent.addClass('google-apple-error-limit-message');
            $('.content__loader.fn-loader div').remove();
            !errorEl[0] && loaderContent.append(p);
        }
    });
});
